import React from 'react';
import './InputBar.css';
import { useDispatch, useSelector } from 'react-redux';
import { setPersonalInfo,clearError } from '../../redux/reducer';

const InputBar = ({ value, label, error }) => {
  const dispatch = useDispatch();

  const handleChange = (e) => {
    console.log(label, e.target.value);
    dispatch(
      setPersonalInfo({
        [label.toLowerCase()]: e.target.value,
      })

      
    );
    dispatch(clearError({ [label.toLowerCase() + "Error"]: "" }))
  };

  return (
    <div className='InputBar'>
      <label className="label">{label}</label>

      <input
        type='text'
        value={value}
        className='Input'
        onChange={handleChange}
      />

      {error && <p className='error'>{error}</p>}
    </div>
  );
};

export default InputBar;